var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "navbar-2 d-flex flex-column top-0 left-0 position-fixed bottom-0 bg-white shadow-md z-1 leading-tight",
      staticStyle: { width: "var(--navbar-width, 256px)" },
    },
    [
      _c(
        "header",
        {
          staticClass:
            "d-flex items-center justify-between tw-p-2 border-bottom border-gray-200",
        },
        [
          _c(
            "a",
            {
              staticClass: "tw-px-2 max-w-[8rem] mr-auto",
              attrs: { href: _vm.loginUrl },
            },
            [
              _c("UiBrandLogoWide", {
                staticClass: "mr-auto",
                attrs: { height: 49 },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "tw-p-2 size-9 text-gray-700",
              staticStyle: { border: "none", "line-height": "1rem" },
              attrs: {
                id: "popover-hub",
                variant: "link",
                "aria-label": _vm.$t("navigation.app_switcher"),
              },
            },
            [
              _c("Icon", {
                staticClass: "size-5 d-inline-block",
                attrs: { icon: "material-symbols:apps-sharp" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              staticClass: "rounded-xl shadow-lg",
              attrs: {
                target: "popover-hub",
                triggers: "click",
                placement: "bottom",
                "custom-class":
                  "w-[293px] max-w-[293px] tw-px-1 tw-py-2 rounded-xl shadow-lg border-gray-200",
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(" "), _c("UiNavbarHub", { ref: "focusedOnShown" })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.navbarLinks && _vm.navbarLinks.length
        ? _c(
            "nav",
            { staticClass: "flex-1 tw-p-2 overflow-auto" },
            [_c("UiNavbarMenu", { attrs: { links: _vm.navbarLinks } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.navbarBottomLinks && _vm.navbarBottomLinks.length
        ? _c(
            "nav",
            { staticClass: "border-top border-gray-200 tw-p-2" },
            [_c("UiNavbarMenu", { attrs: { links: _vm.navbarBottomLinks } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }